// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGallerySidebar__container-c0cae1 {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 100%;
  background-color: var(--addition-80);
}

.MediaGallerySidebar__content-d9c79f {
  flex: 1;
  margin-top: var(--header-height);
  padding: 8px 16px 16px 16px;
  overflow-y: auto;
}

.MediaGallerySidebar__content-d9c79f::-webkit-scrollbar-track {
  background-color: var(--addition-80);
}

.MediaGallerySidebar__description-wrapper-c1dc9a {
  margin-bottom: 16px;
}

.MediaGallerySidebar__description-b73185 {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--addition-50);
}

.MediaGallerySidebar__reactions-de23ea {
  margin-bottom: 16px;
}

.MediaGallerySidebar__divider-a2272c {
  height: 1px;
  margin: 0px 0px 10px 0px;
  border: none;
  background-color: var(--addition-50_10);
}

.MediaGallerySidebar__footer-e89c4c {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-inline-start: -6px;
}

.MediaGallerySidebar__footer-e89c4c > * + * {
  margin-inline-start: 12px;
}

.MediaGallerySidebar__views-c18361 {
  margin-inline-start: auto;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--addition-50);
}

.MediaGallerySidebar__comments-button-f60ba9 > span {
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGallerySidebar/MediaGallerySidebar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;AACF;;AAEA;EACE,OAAA;EACA,gCAAA;EACA,2BAAA;EACA,gBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,wBAAA;EACA,YAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  height: 100%;\n  background-color: var(--addition-80);\n}\n\n.content {\n  flex: 1;\n  margin-top: var(--header-height);\n  padding: 8px 16px 16px 16px;\n  overflow-y: auto;\n}\n\n.content::-webkit-scrollbar-track {\n  background-color: var(--addition-80);\n}\n\n.description-wrapper {\n  margin-bottom: 16px;\n}\n\n.description {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--addition-50);\n}\n\n.reactions {\n  margin-bottom: 16px;\n}\n\n.divider {\n  height: 1px;\n  margin: 0px 0px 10px 0px;\n  border: none;\n  background-color: var(--addition-50_10);\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-inline-start: -6px;\n}\n\n.footer > * + * {\n  margin-inline-start: 12px;\n}\n\n.views {\n  margin-inline-start: auto;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--addition-50);\n}\n\n.comments-button > span {\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGallerySidebar__container-c0cae1`,
	"content": `MediaGallerySidebar__content-d9c79f`,
	"description-wrapper": `MediaGallerySidebar__description-wrapper-c1dc9a`,
	"descriptionWrapper": `MediaGallerySidebar__description-wrapper-c1dc9a`,
	"description": `MediaGallerySidebar__description-b73185`,
	"reactions": `MediaGallerySidebar__reactions-de23ea`,
	"divider": `MediaGallerySidebar__divider-a2272c`,
	"footer": `MediaGallerySidebar__footer-e89c4c`,
	"views": `MediaGallerySidebar__views-c18361`,
	"comments-button": `MediaGallerySidebar__comments-button-f60ba9`,
	"commentsButton": `MediaGallerySidebar__comments-button-f60ba9`
};
module.exports = ___CSS_LOADER_EXPORT___;
